// extracted by mini-css-extract-plugin
export default {"header":"modal_header__xzQZX"};